module.exports = __webpack_public_path__ + "static/media/Icon_cheap_comision.28a5465e.svg";